/**
 * Lọc mảng object theo chuỗi tìm kiếm trên nhiều field.
 */

/**
 * @template T
 * @param {T[]} items
 * @param {string} searchInput
 * @param {string[]} fields - Tên field ghép thành haystack
 * @returns {T[]}
 */
export const filterBySearchText = (items, searchInput, fields) => {
  const query = searchInput.trim().toLowerCase();

  if (!query) {
    return items;
  }

  return items.filter((item) => {
    const haystack = fields
      .map((field) => item[field])
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return haystack.includes(query);
  });
};
